import { FETCH_FLIRTS, FLIRT_LIKE, FLIRT_DISLIKE, FLIRT_SKIP } from './types'
import { FLIRT_ACCOUNTS, ACTIONS } from 'common/endpoints'

export const fetchFlirts = () => ({
  type: FETCH_FLIRTS,
  meta: { url: FLIRT_ACCOUNTS },
})

export const flirtWith = (user, like) => ({
  type: like ? FLIRT_LIKE : FLIRT_DISLIKE,
  meta: { url: ACTIONS.flirt(user, like) },
})

export const flirtSkip = () => ({ type: FLIRT_SKIP })
